'use strict';
import {
  UPDATE_PRODUCT_UPGRADE_MODAL,
  UPDATE_PRODUCT_UPGRADE_MODAL_LOADING_STATUS,
} from '../actions/productUpgradeModal';

const defVal = {
  modalItme: null,
  oprType: null,
  visible: false,
  loading: false,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_UPGRADE_MODAL:
      return Object.assign({}, state, {
        modalItme:action.modalItme,
        visible: action.visible,
      });

    case UPDATE_PRODUCT_UPGRADE_MODAL_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });

    default:
      return state;
  }
};
